<template>
  <div>
    <b-row>
      <b-col
          md="2"
          sm="4"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>

      <b-col
          md="2"
          sm="4"
          class="my-1"
      >
        <b-input-group size="sm">
          <b-form-input
              id="filterInput"
              v-model="hardId"
              type="search"
              placeholder="ID der Rechnung"
          />
          <b-input-group-append>
            <b-button
                @click="SetResetHardByInput()"
            >
              Hart Rest by ID
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>

      <b-col
          md="2"
          sm="4"
          class="my-1"
      />

      <b-col
          md="6"
          class="my-1"
      >
        <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="z.b. Name"
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
            <b-button
                size="sm"
                class="ml-2 btn-info"
                @click="Update"
            >
              Aktualisieren
            </b-button>
            <b-dropdown
              size="sm"
              variant="success"
              class="ml-2"
              text="Neuer Rechnungslauf"
              right
            >
              <b-dropdown-item @click="openRun('sevdesk')">
                SevDesk-Rechnungslauf
              </b-dropdown-item>
              <b-dropdown-item @click="openRun('local')">
                Lokaler Rechnungslauf
              </b-dropdown-item>
            </b-dropdown>
          </b-input-group>
        </b-form-group>

      </b-col>

      <b-col cols="12">

        <div class="text-center">
          <b-spinner
            v-for="variant in variants"
            :key="variant"
            :variant="variant"
            v-show="loading.list"
            class="mr-1"
            type="grow"
          />
        </div>
      </b-col>
      <b-col cols="12"
             v-show="!loading.list"
      >
        <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :items="items"
            :fields="fields"
        >
          <template #cell(BillNumber)="data">
            <b-badge v-if="data.item.InvoiceType == 'RE'" style="color: #e8e8e8; background: #670062">
              Rechnung: {{data.item.InvoiceNumber}}
            </b-badge>
            <b-badge v-if="data.item.InvoiceType == 'WKR'" style="color: #e8e8e8; background: #670062">
              Wiederkehrende Rechnung: {{data.item.InvoiceNumber}}
            </b-badge>
            <b-badge v-if="data.item.InvoiceType == 'SR'" style="color: #e8e8e8; background: #ab1800">
              Stornorechnung: {{data.item.InvoiceNumber}}
            </b-badge>
            <b-badge v-if="data.item.InvoiceType == 'MA'" style="color: #e8e8e8; background: #e39500">
              Rechnungserinnerung: {{data.item.InvoiceNumber}}
            </b-badge>
            <b-badge v-if="data.item.InvoiceType == 'TR'" style="color: #e8e8e8; background: #670062">
              Teilrechnung: {{data.item.InvoiceNumber}}
            </b-badge>
            <b-badge v-if="data.item.InvoiceType == 'TR'" style="color: #e8e8e8; background: #670062">
              Schlussrechnung: {{data.item.InvoiceNumber}}
            </b-badge>
            <b-badge v-if="data.item.InvoiceType == 'CN'" style="color: #e8e8e8; background: #007b8d">
              Gutschrift: {{data.item.InvoiceNumber}}
            </b-badge>
            <b-badge v-if="data.item.InvoiceType == 'LOCAL'" style="color: #e8e8e8; background: #28a745">
              (L)Rechnung: {{data.item.InvoiceNumber}}
            </b-badge>
            <b-badge v-if="data.item.InvoiceType == 'COMMISSION'" style="color: #e8e8e8; background: #007b8d">
              (L)Gutschrift: {{data.item.InvoiceNumber}}
            </b-badge>

            <b-form-input v-if="data.item.InvoiceType == null" v-model="data.item.NewBillNumber">

            </b-form-input>
          </template>
          <template #cell(Status)="data">
            <b-badge v-if="data.item.Status == '50'" style="color: #e8e8e8; background: #04dcbc">
              Deaktivierte Dauerrechnung
            </b-badge>
            <b-badge v-if="data.item.Status == '100'" style="color: #e8e8e8; background: #0469dc">
              Entwurf
            </b-badge>
            <b-badge v-if="data.item.Status == '200'" style="color: #e8e8e8; background: #eca100">
              Offen
            </b-badge>
            <b-badge v-if="data.item.Status == '1000'" style="color: #e8e8e8; background: #319400">
              Bezahlt
            </b-badge>
            <b-badge v-if="data.item.Status == null" style="color: #e8e8e8; background: #670062">
              Unbekannte Rechnung
            </b-badge>
          </template>

          <template #cell(Send)="data">

          <b-badge :variant="Number(data.item.MailId || 0) > 0 ? 'success' : 'danger'">
            {{ Number(data.item.MailId || 0) > 0 ? 'Ja' : 'Nein' }}
          </b-badge>
          </template>
          <template #cell(ActionPdf)="data">
            <div @click="OpenPdf(data.item.BillNumber, data.item.Hash, data.item)">
              <b-avatar
                size="24"
                badge
                :src="require('@/assets/images/icons/pdf.png')"
                class="badge-minimal"
                :badge-variant="data.item.HasFile ? 'success' : 'danger'"
              />
            </div>
          </template>
          <template #cell(Customer)="data">
            {{ data.item.CustomerNumber }} - {{ data.item.CustomerName }}
          </template>
          <template #cell(Action)="data">

            <b-dropdown
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="btn-icon"
                dropleft
                variant="flat-success"
            >

              <b-dropdown-item
                  @click="SendMail(data.item)"
                  v-if="data.item.Status != '100'"
              >

                <div>
                  <feather-icon
                      icon="CheckIcon"
                      size="22"
                  />
                  Per mail Versenden ({{data.item.Customer.Mail}})
                </div>
              </b-dropdown-item>
              <b-dropdown-item
                  @click="SetReset(data.item.BillNumber)">
                <div>
                  <div
                      v-show="loading.reset"
                      class="spinner-border spinner-border-sm mr-1"
                      size="22"
                      role="status"
                  >
                    <span class="sr-only">Loading...</span>

                  </div>
                  <feather-icon
                      v-show="!loading.reset"
                      icon="TrashIcon"
                      size="22"
                  />
                  Zurücksetzen
                </div>
              </b-dropdown-item><b-dropdown-item
                  @click="SetResetHard(data.item.BillNumber)">
                <div>
                  <div
                      v-show="loading.reset"
                      class="spinner-border spinner-border-sm mr-1"
                      size="22"
                      role="status"
                  >
                    <span class="sr-only">Loading...</span>

                  </div>
                  <feather-icon
                      v-show="!loading.reset"
                      icon="TrashIcon"
                      size="22"
                  />
                  HART Zurücksetzen
                </div>
              </b-dropdown-item>
              <!--nur für lokale Rechnungen/Gutschriften -->
              <b-dropdown-item
                v-if="data.item.InvoiceType === 'LOCAL' || data.item.InvoiceType === 'COMMISSION'"
                @click="MarkAsPaid(data.item.BillNumber)"
              >
                <div>
                  <feather-icon icon="DollarSignIcon" size="22"/>
                  Als bezahlt markieren
                </div>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="data.item.InvoiceType === 'LOCAL' || data.item.InvoiceType === 'COMMISSION'"
                @click="DeleteLocalInvoice(data.item.BillNumber)"
              >
                <div>
                  <feather-icon icon="TrashIcon" size="22"/>
                  Löschen
                </div>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-col>

      <b-col
          cols="12"
      >
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            v-show="!loading.list"
            align="center"
            size="sm"
            class="my-0"
        />
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem, BSpinner
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  name: 'billingList',
  components: {
    BSpinner,
    BDropdown,
    BDropdownItem,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      variants: ['primary', 'secondary', 'danger', 'warning', 'success', 'info', 'light', 'dark'],
      loading: {
        list: false,
        reset: false
      },
      hardId: '',
      lastClickedRow: -1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'BillNumber',
          label: 'R.Nr.',
        },
        {
          key: 'Date',
          label: 'Datum',
        },
        {
          key: 'Status',
          label: 'Status',
        },
        {
          key: 'Send',
          label: 'Versendet',
        },
        {
          key: 'From',
          label: 'von Datum',
        },
        {
          key: 'To',
          label: 'Bis Datum',
        },
        {
          key: 'Customer',
          label: 'Kunde',
        },
        {
          key: 'NetSum',
          label: 'Netto',
        },
        {
          key: 'GrossSum',
          label: 'Brutto',
        },
        {
          key: 'VoucherCount',
          label: 'Fahrten',
        },
        {
          key: 'ActionPdf',
          label: 'Pdf',
        },
        {
          key: 'Action',
          label: '',
        },
      ],
      items: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key,
          }))
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Rechnungen'
    })
    this.LoadList()
    // Set the initial number of items
    this.totalRows = this.items.length
    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadList()
        },
    )

    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
        () => this.filter,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
  },
  methods: {
    async DeleteLocalInvoice(billNumber) {
      this.$swal({
        title: 'Löschen',
        text: 'Soll die lokale Rechnung/Gutschrift wirklich gelöscht werden?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, löschen!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            const resp = await this.$http.post('/invoice/local/delete', {
              billNumber: billNumber
            })
            if (resp.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Gelöscht',
                  icon: 'TrashIcon',
                  text: 'Die lokale Rechnung wurde gelöscht.',
                  variant: 'success',
                },
              })
              this.LoadList()
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'AlertCircleIcon',
                  text: resp.data.message || 'Konnte nicht gelöscht werden.',
                  variant: 'danger',
                },
              })
            }
          } catch (err) {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'AlertCircleIcon',
                text: 'Serverfehler beim Löschen.',
                variant: 'danger',
              },
            })
          }
        }
      })
    },
      async MarkAsPaid(billNumber) {
      try {
        const resp = await this.$http.post('/invoice/local/setPaid', {
          billNumber: billNumber
        })

        if (resp.data.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Bezahlt',
              icon: 'CheckIcon',
              text: 'Rechnung wurde als bezahlt markiert.',
              variant: 'success',
            },
          })
          this.LoadList() // Liste neu laden
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Fehler',
              icon: 'AlertCircleIcon',
              text: 'Status konnte nicht geändert werden.',
              variant: 'danger',
            },
          })
        }
      } catch (err) {
        console.error(err)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Fehler',
            icon: 'AlertCircleIcon',
            text: 'Serverfehler beim Ändern des Status.',
            variant: 'danger',
          },
        })
      }
    },
    OpenPdf(billNumber, shash, row) {
      // row ist das gesamte Zeilenobjekt
      const isLocal = row && (row.InvoiceType === 'LOCAL' || row.InvoiceType === 'COMMISSION')

      // Lokale Rechnungen per /invoice/local/pdf?id=localId
      const url = isLocal
        ? `/invoice/local/pdf?id=${billNumber}`
        : `/invoice/pdf?billnumber=${billNumber}&hstring=${shash}`

      this.$http.get(url, { responseType: 'blob' })
        .then(resp => {
          window.open(URL.createObjectURL(resp.data))
        })
        .catch(err => {
          console.error(err)
        })
    },
    SendMail(invoice) {
      let url = '/invoice/send/mail'
      let payload = {
        InvoiceId: invoice.BillNumber,
        Email: invoice.Customer.Mail,
      }

      if (invoice.Source === 'LOCAL') {
        url = '/invoice/send/localmail'
        payload = {
          InvoiceId: invoice.BillNumber,
          Email: invoice.Customer.Mail,
        }
      }

      this.$http.post(url, JSON.stringify(payload))
        .then(resp => {
          if (resp.data.success) {

            invoice.MailId = 1
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Ok',
                icon: 'CheckIcon',
                text: 'Rechnung wird versendet.',
                variant: 'info',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'XIcon',
                text: resp.data.message || 'Es ist ein Fehler aufgetreten.',
                variant: 'danger',
              },
            })
          }
        })
        .catch(err => {
          console.error(err)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Fehler',
              icon: 'XIcon',
              text: 'Serverfehler beim Mailversand',
              variant: 'danger',
            },
          })
        })
    },

    SetResetHardByInput() {
      this.SetReset(this.hardId, true);
    },
    SetResetHard(billNumber) {
      this.SetReset(billNumber, true);
    },
    SetReset(billNumber, hard = false) {
      if(this.loading.reset) {
        this.$swal({
          icon: 'warning',
          title: 'Bitte warten!',
          text: 'Rechnung werden derzeit noch zurückgesetzt.',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
        return
      }

      this.$swal({
        title: 'Zurückgesetzen',
        text: 'Soll die Rechnung wirklich zurückgesetzt werden?' + (hard ? 'HART' : ''),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, zurücksetzen!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.value) {
                this.loading.reset = true;
                this.$http.post('/invoice/resetInvoice', JSON.stringify({billNumber: billNumber, HardReset: hard}), { timeout: 120000 })
                  .then(resp => {
                    if (resp.data.success) {
                      this.loading.reset = false;
                      this.$swal({
                        icon: 'success',
                        title: 'Zurückgesetzt!',
                        text: 'Rechnung Zurückgesetzt.',
                        customClass: {
                          confirmButton: 'btn btn-success',
                        },
                      })
                    } else {
                      this.loading.reset = false;
                      this.$swal({
                        icon: 'error',
                        title: 'Fehler',
                        text: 'Es ist ein Fehler aufgetreten.',
                        customClass: {
                          confirmButton: 'btn btn-danger',
                        },
                      })
                    }
                  })
                  .catch(err => {
                    console.error(err)
                    this.loading.reset = false;
                    this.$swal({
                      icon: 'error',
                      title: 'Fehler',
                      text: 'Es ist ein Fehler aufgetreten.',
                      customClass: {
                        confirmButton: 'btn btn-danger',
                      },
                    })
                  })

            }
          })


    },
    New() {
      this.$router.push({
        name: 'BillingRun',
        params: {id: 0}
      })

    },
    Click(record, index) {
      this.$router.push({
        name: 'customer',
        params: {id: record.IdentId}
      })
    },

    openRun(mode) {
    if (mode === 'sevdesk') {
      // Route oder Modal für SevDesk-Lauf
      this.$router.push({
        name: 'BillingRun',
        params: { id: 0 }
      });
    } else if (mode === 'local') {
      // Route oder Modal für lokalen Lauf
      this.$router.push({
        name: 'InvoiceRunLocal'
      });
    }
  },
  paymentMethodText(method) {
    switch (method) {
      case 0: return "Keine Angabe"
      case 1: return "Rechnung"
      case 2: return "Lastschrift"
      case 3: return "Barzahlung"
      default: return "Unbekannt"
    }
  },


    Update() {
      this.loading.list = true;
      this.$http.get("/invoice/update",  {timeout: 60000})
          .then(resp => {
            this.LoadList();
          })
          .catch(err => {
            console.error(err)
          })
    },
    async LoadList() {
      this.loading.list = true
      this.items = []

      const c1 = (this.currentPage - 1) * this.perPage
      let urlSev   = `/invoice/list?from=${c1}&count=${this.perPage}`
      let urlLocal = `/invoice/local/list?from=${c1}&count=${this.perPage}`

      if (this.filter && this.filter !== '') {
        urlSev   = `/invoice/list?from=${c1}&count=${this.perPage}&filter=${encodeURIComponent(this.filter)}`
        urlLocal = `/invoice/local/list?from=${c1}&count=${this.perPage}&filter=${encodeURIComponent(this.filter)}`
      }

      try {
        const [sevRes, localRes] = await Promise.allSettled([
          this.$http.get(urlSev,   { timeout: 60000 }),
          this.$http.get(urlLocal, { timeout: 60000 }),
        ])

        let sev = { list: [], info: { fullEntries: 0 } }
        let loc = { list: [], info: { fullEntries: 0 } }

        if (sevRes.status === 'fulfilled') {
          sev = sevRes.value.data || sev
        } else {
          console.warn('SevDesk-Request fehlgeschlagen:', sevRes.reason)
        }

        if (localRes.status === 'fulfilled') {
          loc = localRes.value.data || loc
        } else {
          console.warn('Lokaler-Request fehlgeschlagen:', localRes.reason)
        }

        // zusammenführen & nach Datum sortieren
        const combined = [...(sev.list || []), ...(loc.list || [])]
          .sort((a, b) => new Date(b.Date) - new Date(a.Date))

        // Gesamt für Pagination
        this.totalRows =
          (sev.info?.fullEntries || 0) +
          (loc.info?.fullEntries || 0) ||
          combined.length

        // Datumsformatierung
        const fmt = d => {
          const x = new Date(d)
          const ye = new Intl.DateTimeFormat('de', { year: '2-digit' }).format(x)
          const mo = new Intl.DateTimeFormat('de', { month: '2-digit' }).format(x)
          const da = new Intl.DateTimeFormat('de', { day: '2-digit' }).format(x)
          return `${da}.${mo}.${ye}`
        }

        this.items = combined.map(i => {
          const copy = { ...i }
          if (copy.From) copy.From = fmt(copy.From)
          if (copy.To)   copy.To   = fmt(copy.To)
          if (copy.Date) copy.Date = fmt(copy.Date)
          if (copy.Customer && !copy.CustomerName) {
            copy.CustomerName = `${copy.Customer.CustomerNumber} - ${copy.Customer.Name}`
          }
          return copy
        })
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.list = false
      }
    },
  },
}
</script>
